import {
  checkMigratedCustomer,
  checkUserLogin,
  createAccessToken,
  createUserLogin,
  customerLoginData,
  encryptString,
  extractUserCauseFromTags,
  generateMultiPassURL,
  performKlaviyoMerge,
  updateUserWishlistID,
} from "@/helpers/userHelpers";
import Link from "next/link";
import {handleOpeningOfAccountSidebar, loggedInUser, openAccountSidebar, openForgotSidebar, updateAuthCookie } from "@/redux/actions/loggedInUser";
import { isMenuVisible} from "@/redux/actions/headerAction";
import { deleteCookie, getCookie, setCookie } from "cookies-next";
import { useRouter } from "next/compat/router";
import React, { useEffect, useId, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Srcset from "@/components/common/Srcset";
import styles from "components/Header/Account/Account.module.scss";
import { errorMessages, generalConstants } from "@/utils/constants";
import { KlaviyoUserSignIn } from "@/components/common/Klaviyo";
import { setCustomer } from "@/components/common/Nosto";
import { updateUserCheckoutID } from "@/helpers/userHelpers";
import { mergeUsersCart} from "@/helpers/cartHelpers";
import { addToCart, updateCart } from "@/redux/actions/addToCartAction";
import {checkIfEmail, isPWAVisits, redirectToUrl} from "@/helpers/generalHelper";
import { saveUserCharityLocalStorage, updateCartWhenCharityUpdates, getUserCauseFromUserTag } from "@/helpers/charityHelper";
import { setUserCause } from "@/redux/actions/generalAction";
import { reportError } from "@/helpers/errorHelper";
import { crossDeviceTracking } from "@/components/common/Tracking";
import { addToWishlist,initializeWishlist, wishlistNotInit } from "@/redux/actions/wishlistAction";
import { getWishlistProducts, mergeUsersWishlist } from "@/helpers/wishlistHelpers";
import { openWishlistSidebar } from "@/redux/actions/wishlistAction";
import { WelcomeJourneyState, isGuest,isVisited,welcomeStep } from "@/redux/actions/pwaAction";
import InputField from "@/components/common/CommonInputComponent";

const SignUp = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [migratedApiCheck, setMigratedApiCheck] = useState(false);
  const [validEmail, setValidEmail] = useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = useState();
  const [passwordErrorMessage, setPasswordErrorMessage] = useState();
  const [passwordType, changePasswordType] = useState(true);
  const [formError, setFormError] = useState(false);
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const emailId = useId();
  const passwordId = useId();
  const rememberCheck = useId();
  const rememberCheckboc = useRef();
  const dispatch = useDispatch();
  const user_cause = useSelector((state) => state.general.user_cause);
  var rewards_redirect = getCookie("redirect_path");
  const default_cause = useSelector((state) => state.general.default_cause);
  const cause_list = useSelector((state) => state.general.cause_list);
  const wishlistItems = useSelector((state) => state.wishlist.wishlist);
  const wishlistSidebarOpen = useSelector(
    (state) => state.wishlist.open_wishlist_sidebar
  );
  const accountSidebarOpen = useSelector(
    (state) => state.loginUser.open_account_sidebar
  );
  const isUserloggedIn = useSelector(
    (state) => state.loginUser.userLoggedIn
  );
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  const checkPwaGuest = useSelector((state) => state.pwa.is_guest);
   //To track if sign in done through wishlist
  let wishlist_cookie = getCookie("show_wishlist");
  const wc_journey_step = useSelector((state) => state.pwa.welcome_journey.currentStepNo);
  
  const welcomeJourneyStates = useSelector((state) => state.pwa.welcome_journey);

  useEffect(() => {
    if (autoFillEmail) {
      setEmail(autoFillEmail);
    }
    if (getCookie("user_email_address")) {
      setEmail(getCookie("user_email_address"));
      setCookie("user_email_address", null);
    }
    rememberCheckboc.current.checked = true
  }, []);
  useEffect(() => {
    setEmailErrorMessage();
    setValidEmail(false);
    setPasswordErrorMessage();
    setLoading(false);
    setFormError(false);
    changePasswordType(true);
  }, [props.accountSidebarOpen]);
  let { setShowResetPassword, autoFillEmail, setEmailAtActivateAccount } = props;
  


  async function handleEmailFormat(event) {
    let emailVal =
      event.target.email && event.target.email.value
        ? event.target.email.value
        : event.target.value;
    if (emailVal) {
      var validateEmail = checkIfEmail(emailVal);
      setValidEmail(validateEmail);
      if (!validateEmail) {
        if (formError) {
          setFormError("");
        }
        setEmailErrorMessage(errorMessages.authentication.invalidEmail);
      } else {
        setEmailErrorMessage(null);
        if(!migratedApiCheck) {
          const response1 = await checkMigratedCustomer(emailVal);
          setMigratedApiCheck(true);
          props.setSubmittedEmail(emailVal);
          if(response1) {
            props.setMigratedUserState(response1);
            setShowResetPassword("activateAccountTab"); 
            setEmailAtActivateAccount(true);
          }
        }
      }
      if (email) {
      } else {
        setEmailErrorMessage(null);
      }
    } else {
      if (formError) {
        setFormError("");
      }
      setEmailErrorMessage(errorMessages.authentication.emptyEmail);
    }
  }

  function handlePasswordFormat(event) {
    let passwordVal =
      event.target.password && event.target.password.value
        ? event.target.password.value
        : event.target.value;
    if (passwordVal) {
      setPasswordErrorMessage(null);
    } else {
      setPasswordErrorMessage(errorMessages.authentication.emptyPassword);
    }
  }

  const handleChange = (event) => {
    //Check All fileds are filled or not
    if (formError) {
      setFormError("");
    }
    switch (event.target.name) {
      case "email":
        setEmail(event.target.value);
        setMigratedApiCheck(false);
        break;
      case "password":
        setPassword(event.target.value);
        break;
    }
  };

  // initialize user cause
  const validateAccessToken = async (token) => {
    let user_data = await checkUserLogin(token);
    if (user_data && user_data.userLoggedIn) {
      dispatch(loggedInUser(user_data));
      //This code get the user's cause from the tags and saves it in the local storage
      let causeInUrl = false;
      if(typeof window !== "undefined"){
        if(window.location.search.includes("cause")) {
          causeInUrl = true;
        }
      }
      if(user_data?.userData?.tags && !causeInUrl){
        let cause = await extractUserCauseFromTags(user_data.userData.tags)
        if(cause.length > 0){
          saveUserCharityLocalStorage(cause[0])
          dispatch(setUserCause(cause[0]))
        }
        else {
          // Update user cause in shopify when creating new account
          let causeToBeAdded = null;
          if(user_cause) causeToBeAdded = user_cause;
          else if(default_cause) causeToBeAdded = default_cause;
          try {
            causeToBeAdded = JSON.parse(causeToBeAdded);
          }
          catch(error) {
            reportError("Cause string format error");
            reportError(error);
          }
          if(causeToBeAdded) {
            if (cause_list) {
              const cause = cause_list.find(
                (cause) => cause.short_code === causeToBeAdded
              );
              if (cause) {
                const request = { cause: causeToBeAdded }
                console.log('updateUserCause signUp=====')
                updateUserCause(request);
                //Update cause realted custom attribute for cart line items
                updateCartWhenCharityUpdates(causeToBeAdded,cause_list);
                var updatedCartList = JSON.parse(sessionStorage.getItem("cart_list"));
                dispatch(updateCart(updatedCartList));
                dispatch(setUserCause(causeToBeAdded));
              }
            }
          }
        }
      }

    } else {
      dispatch(loggedInUser({}));
      // setUserName("");
    }
    return user_data;
  };

  //OS-5049 the klaviyo actions are separated in this function to execute after 2 seconds of delay
  const performKlaviyoAction = async (userData,response) => {
    try {
      if(localStorage.getItem('klaviyo_external_id') && userData?.customer?.email) {
        await performKlaviyoMerge(userData?.customer?.email,localStorage.getItem('klaviyo_external_id'));        
      }   
    }
    catch(error) {
      reportError("klaviyo profile merge failed in sign up");
      reportError(error);
    }
    if (isPWA) {
      window?.ReactNativeWebView?.postMessage(JSON.stringify({customerAccessToken:response.customerAccessTokenCreate}))
      // window?.ReactNativeWebView?.postMessage(JSON.stringify({message: "Login added"}));
    }
  }

  const guestCheckoutRedirectOnLogin = async(userData) => {
    // Extract the checkout_url from the query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const checkoutUrl = urlParams.get('checkout_url');  // This gets the full checkout URL
    const checkoutIdMatch = checkoutUrl.match(/\/checkouts\/cn\/([a-zA-Z0-9_-]+)/);
    const checkoutId = checkoutIdMatch[1];
    if (checkoutUrl && checkoutIdMatch && checkoutId) {
      try {
        const multiPassURL = await generateMultiPassURL({
          token: userData,
          url: `https://${process.env.SHOPIFY_STORE_DOMAIN}/cart/c/${checkoutId}`
        });
        if (multiPassURL.url) {
          router.push(multiPassURL.url);
          return;
        }
      } catch (err) {
        console.error("Error in generating Multipass URL", err); 
      }
    }
  };
  

  // Handles the submit event on form submit.
  const handleSubmit = async (event) => {
    event.preventDefault();
    handleEmailFormat(event);
    handlePasswordFormat(event);
    // Get data from the form.
    
    if(email && password && checkIfEmail(email)) {
    const data = {
      email: event.target.email.value,
      password: event.target.password.value,
    };
    setLoading(true);
    const response = await createAccessToken(data);
    if (response.status === 406) {
        setFormError(
          errorMessages.authentication.incorrectEmailOrPassword
        );
    }
    if (
      response &&
      response.customerAccessTokenCreate &&
      response.customerAccessTokenCreate.customerAccessToken
    ) {
      setCookie("cookie_initial_checkout", "redo");
      await createUserLogin(response.customerAccessTokenCreate);
      localStorage.setItem('klaviyo_external_profile_id','');
      deleteCookie('klaviyo_profile_identified')
      if(typeof klaviyo !== 'undefined' && klaviyo){
          klaviyo.identify({'email' : event.target.email.value});
          setCookie('klaviyo_profile_identified', "true")
      } 
      // FETCH USER DATA FROM SHOPIFY USING ACCESS TOKEN
      const userData = await customerLoginData({
        token:
          response.customerAccessTokenCreate.customerAccessToken.accessToken,
      });
      console.log("userData=====",userData)
      let userTagCause = getUserCauseFromUserTag(userData);
      if(userTagCause && userTagCause != ''){
        saveUserCharityLocalStorage(userTagCause);
      }
      let expiry = false;
      if (rememberCheckboc.current.checked) {
        expiry = true;
      }
      KlaviyoUserSignIn(userData)
      await createUserLogin(
        response.customerAccessTokenCreate,
        userData,
        expiry
      );
      
      dispatch(loggedInUser(true));
      setCustomer(userData)
      dispatch(isMenuVisible(false));
      guestCheckoutRedirectOnLogin(response.customerAccessTokenCreate.customerAccessToken.accessToken);

      //OS-5049 #delay added before calling klaviyo action items
      setTimeout(() => {
        performKlaviyoAction(userData,response)
      }, 2000);
      
      /* START: OS-2078 - Retain user cart */
      let checkoutId;
      // checkoutId = getCookie("checkoutId");
      // if (!checkoutId) {
        checkoutId = localStorage.getItem("pwacheckoutId")
      // }
      let checkoutIdSaved = userData?.customer?.checkout_id?.value;
      if (typeof checkoutId !== "undefined" && checkoutId != "" && checkoutId != "NA") {
        //if cart already exists before login
        if (typeof checkoutIdSaved !== "undefined" && checkoutIdSaved != "" && checkoutIdSaved != "NA" && checkoutIdSaved != checkoutId) {
          // setCookie("checkoutId", checkoutIdSaved); //Overwrite cookie with saved cart
          localStorage.setItem("pwacheckoutId", checkoutIdSaved);
          let mergedCartResponse = await mergeUsersCart(checkoutId);
          if (mergedCartResponse?.id) {
            checkoutId = btoa(mergedCartResponse?.id);
            dispatch(addToCart(mergedCartResponse));
          }
        }
        if (
          response?.customerAccessTokenCreate?.customerAccessToken?.accessToken
        ) {
          await updateUserCheckoutID({
            checkout_id: checkoutId,
            customerAccessToken:
              response.customerAccessTokenCreate.customerAccessToken
                .accessToken,
          });
        }
      } else {
        // setCookie("checkoutId", checkoutIdSaved);
        localStorage.setItem("pwacheckoutId", checkoutIdSaved);
      }
      
      /* END: OS-2078 - Retain user cart */
      // wishlist retain
      // check for wishlist hash if its present on local storage
      let wishlishtHashID = localStorage.getItem("wishlistHash");
      //  users existing id which is present inside shopify
      let wishlistIdSaved = userData?.customer?.wishlist_id?.value;
      //SUP-3734 #below is done to update the hash id in case of object object to empty
      if((typeof wishlishtHashID != "undefined" && wishlishtHashID != "" && !wishlistIdSaved && wishlistIdSaved?.toLowerCase()=="[object object]")) {
        wishlistIdSaved = '';
      }
      if (typeof wishlishtHashID != "undefined" && wishlishtHashID != "") {
        //if wishlist already exists before login
        if (typeof wishlistIdSaved != "undefined" && wishlistIdSaved != "" && wishlistIdSaved != wishlishtHashID) {
          const usersWishlistItems = await getWishlistProducts({HashId: wishlistIdSaved,timeout:100})
          if(!usersWishlistItems || !usersWishlistItems?.length) {
            setCookie('WISHLIST_USER_HASH',wishlistIdSaved);
            setCookie('WISHLIST_USER_WEB',wishlishtHashID);
            dispatch(wishlistNotInit(true))
          }
          localStorage.setItem("wishlistHash",wishlistIdSaved) // overwrite wishlist id
          //  merge wishlist
          let mergedWishlistResponse = await mergeUsersWishlist(wishlishtHashID,wishlistIdSaved,usersWishlistItems,100);

          //fetching the fresh list if wishlist
          const testAgainWishlistItems = await getWishlistProducts({HashId: wishlistIdSaved,timeout:100})
          if (mergedWishlistResponse) {
            // usersWishlistItems.forEach(item=>{
            //   const itemExistsInWishlist = wishlistItems.some((item1) => {
            //     return item1.ProductVariantId ===  item.ProductVariantId;
            //   });
            //   if(!itemExistsInWishlist){
            //     dispatch(addToWishlist(item));
            //   }
            // })
            sessionStorage.setItem(
              "wishlist",
              JSON.stringify({ items: testAgainWishlistItems })
            );
            dispatch(
            initializeWishlist({
              wishlistHashId: wishlistIdSaved,
              wishlist: testAgainWishlistItems,
            }))
          }
        }
        //  if users wishlist id is not there then make a api call to update wishlist id
        else if (!wishlistIdSaved) {
          //  function to push wishlist id of user into shopify
          await updateUserWishlistID({
            wishlist_id: wishlishtHashID,
            customerAccessToken:
              response.customerAccessTokenCreate.customerAccessToken
                .accessToken,
          });
        }
      } else {
        localStorage.setItem("wishlistHash",wishlistIdSaved)
      }

      if(userData?.customer?.tags.includes(generalConstants.user_discount_tag)) {
        setCookie(generalConstants.user_discount_tag,true);
      }
      // else if (userData?.customer?.tags.includes(generalConstants.user_discount_tag2)) {
      //   setCookie(generalConstants.user_discount_tag2,true);
      // }
      
      if (rewards_redirect) {
        //Redirect to your bag page when logged in from mini cart
        deleteCookie(rewards_redirect);    
        dispatch(openAccountSidebar(false));  
        window.location.href = "/your-bag";
      }
       //Redirect to particular path if redirect_url is present
      else if(router.query.redirect_url){
        redirectToUrl(router.query.redirect_url);
      }
      else if(props.drawer_section === 'login' || props.drawer_section === 'register' || props.drawer_section === 'activate-account') {
        // router.reload('/account');
        if(getCookie("userdataToken")) {
          let cookie_data=JSON.parse(getCookie("userdataToken"));
          // syncing user cause
          validateAccessToken(cookie_data.accessToken);
          dispatch(updateAuthCookie(cookie_data))
        }
      }
      else {
         // check if the token exists
        if (getCookie("userdataToken")) {
          let cookie_data = JSON.parse(getCookie("userdataToken"));
          // track user ids in GA4
          crossDeviceTracking(cookie_data.accessToken);
          // syncing user cause
          validateAccessToken(cookie_data.accessToken);
          dispatch(updateAuthCookie(cookie_data));
        }
        
        // else {
        //   // during pwa welcome journey step donot close the side bar
        //   !checkPwaGuest && dispatch(openAccountSidebar(false))
        // }
        //SUP-2733 :If page path is /rewards or / then reload on login
        if(isPWA && wc_journey_step !== 6) {
          dispatch(welcomeStep(true))
  
        } else {
          dispatch(openAccountSidebar(false))
          if (router.asPath.includes("rewards")||router.asPath==("/")) {
              window.location.reload();
            if (isUserloggedIn) {
              if (typeof yotpoWidgetsContainer != "undefined" && typeof yotpoWidgetsContainer != undefined) {
                  yotpoWidgetsContainer.initWidgets();
              }
            }
          }
        }
        //OS-5691 #redirect to account/orders page on login
        if (router?.asPath.includes("account/orders")) {
          dispatch(openAccountSidebar(true))
        }
        //OS-3257 : Added reload to refresh yotpo points in sticky rewards banner on login
        if(getCookie("currentPageType")){
          let page_type_cookie = JSON.parse(getCookie("currentPageType"));
        }
    
      }
      //this fucntion is used to show the wishlist drawer only if user is clicking on wishlist sign in or create account link
      if(getCookie('show_wishlist')){
        setTimeout(() => {
          dispatch(openWishlistSidebar(true))
        }, 5000);
        deleteCookie("show_wishlist");
        if (router.asPath.includes("rewards")||router.asPath==("/")) {
          setCookie('show_wishlist_reload',true)
        };    
      }
    } else {
      dispatch(loggedInUser(false));
      // setCookie("userdataToken", null);
      setCookie("cookie_initial_checkout", "redo");
    }
    setLoading(false);
    }
  };

  const handleAsGuest = () => {
    dispatch(openAccountSidebar(false));
    dispatch(WelcomeJourneyState({ ...welcomeJourneyStates, addWCOverlay: true,currentStepNo:5 }));

  };

  const handleBlurOut = (targert, placeholderText) => {

    if(targert) {
      targert.placeholder = placeholderText
    }
  }
  const togglePasswordVisibility = () => {
    changePasswordType(!passwordType);
  };
  return (
    <form onSubmit={handleSubmit} className={`${styles.form_wrap}`}>
      <InputField
          type="text"
          id={emailId}
          name="email"
          label="Email*"
          placeholder=" "
          autoComplete="email"
          ariaLabel="your-email"
          className="normal-md small-xs normal-sm auto-signIn-email"
          errorMessage={emailErrorMessage}
          formError={formError}
          onFocus={e => e.currentTarget.placeholder = ``}
          onChange={handleChange}
          onBlur={(e) => {handleEmailFormat(e); 
          }}
          isEmail={true}
          isSignInTab={true}
        />
      <InputField
          type={passwordType ? 'password' : 'text'}
          id={passwordId}
          name="password"
          label="Password*"
          placeholder=" "
          autoComplete="password"
          ariaLabel="your-password"
          className="normal-md small-xs small-sm auto-signIn-pwd"
          errorMessage={passwordErrorMessage}
          formError={formError}
          onFocus={(e) => (e.currentTarget.placeholder = '')}
          onChange={handleChange}
          onBlur={(e) => {
            handlePasswordFormat(e);
          }}
          value={password}
          isPassword={true}
          isSignInTab={true}
          togglePasswordVisibility={togglePasswordVisibility}
          isPasswordVisible={!passwordType}
        />
      <div
        className={`${styles.form_item} ${styles.marketing_field} ${
          styles.form_forgot_flex
        } ${passwordErrorMessage ? styles.pwd_position : ""}`}
      >
        <div className="custom-checkbox custom-checkbox-sm">
          <input
            name="rememberChkBox"
            id={rememberCheck}
            type="checkbox"
            ref={rememberCheckboc}
            className="remember-me"
          />
          <label className="x-small-xs x-small-sm x-small-md" htmlFor={rememberCheck}>Remember me</label>
        </div>
        <div className={`${styles.form_forgot} x-small-xs x-small-sm x-small-md`}>
          <a
            onClick={() => {
              setShowResetPassword("resetPassword");
              dispatch(openForgotSidebar(true))
            }}
            className="forgot-password"
            tabIndex={0}
          >
           {isPWA ? "Forgot your password?" : "Forgotten your password?"}
          </a>
        </div>
      </div>
      <div className={`${isPWA && checkPwaGuest && wc_journey_step !== 6 ? styles.login_wrapper : ''}`}>
      <div className={`${styles.form_btn}`}>
        <button
          tabIndex={0}
          type="submit"
          className={`normal btn-primary auto-login-btn ${styles.btn_loading} ${
            loading ? "loading" : ""
          }`}
        >
          {/* css conditions to check user is in PWA and in a welcome journey step */}
          <div className={`${wishlist_cookie&&"ga_wishlist_login"} ${ isPWA && checkPwaGuest ? "ga_pwa_account_login":"ga_account_login"}`}>
          Log in
          </div>
        </button>
      </div>
      {((isPWA && !checkPwaGuest) || !isPWA) && <div className={`${isPWA && checkPwaGuest && wc_journey_step !== 6 ? styles.pt_20 : '' } ${styles.form_assistance}`}>
        <p className="small-xs normal-sm normal-md para-with-link">
          Need assistance? Contact us by{" "}
          <Link tabIndex={0} href={`mailto:${generalConstants.help_email}`}>
              <span className="ga-help">email</span>
          </Link>
        </p>
      </div>}
      {isPWA && checkPwaGuest && <div className={`${styles.guest_div}`}>
        <p className="pwa-link-tag x-small-xs" onClick={handleAsGuest}>
          <Link href="/" className="ga_pwa_guest underline" data-ga4="App: WJ - Sign in > Continue as guest">
            Continue as guest
          </Link>
        </p>
      </div>}
      </div>
      {/* check for the guest users */}
      
    </form>
  );
};

export default SignUp;
